(() => {
 'use strict';
 if(window.TplCatalogueIndex)return;
 const instances=new WeakMap();
 const normalize=value=>String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\bt[\s-]?shirts?\b/g,'tee').replace(/\b(sneakers?|baskets?)\b/g,'sneaker').replace(/\b(mocassins?|moccasins?|loafers?)\b/g,'moccasin').replace(/\bnoir(?:e?s)?\b/g,'black').replace(/\bblanc(?:s|he|hes)?\b/g,'white').replace(/\bbleu(?:e?s)?\b/g,'blue').replace(/\bgris(?:e|es)?\b/g,'grey').replace(/\bvert(?:e?s)?\b/g,'green').replace(/\b(?:gift[ -]?cards?|cartes? cadeaux?|cadeaux?)\b/g,'gift card').replace(/\b(?:debardeurs?|tank[ -]?tops?)\b/g,'tank').replace(/\b(?:sous[ -]?vetements?|underwear)\b/g,'underwear').replace(/\b(?:runners?|running)\b/g,'running').replace(/\b(?:slip[ -]?ons?)\b/g,'slip on').replace(/\b(?:sliders?|slides?|claquettes?)\b/g,'slides').replace(/\b(?:hoodies?|sweatshirts?)\b/g,'hoodie').replace(/[^a-z0-9]+/g,' ').trim();
 const isLineQuery=query=>/^tpl(?: |$)/.test(normalize(query));
 const matches=(record,query)=>{const q=normalize(query);if(isLineQuery(q)&&!record.tplLine)return false;return q.replace(/^tpl by the proper label\b/,'').replace(/^tpl\b/,'').split(' ').filter(Boolean).every(word=>record.text.includes(word));};
 const create=menu=>{
  const source=menu.querySelector('[data-tpl-index-template]'),panel=menu.querySelector('#TplMenuSearchIndex');
  const copy=JSON.parse(menu.querySelector('[data-tpl-catalogue-copy]')?.textContent||'{}');
  const records=new Map();let promise,complete=false,loading=false,error=false;
  const merge=record=>{
   const previous=records.get(record.id);
   if(previous&&!previous.archive&&record.archive)return;
   if(previous)record.text=previous.text+' '+record.text;
   records.set(record.id,record);
  };
  source?.content.querySelectorAll('[data-tpl-index-piece]').forEach((el,i)=>{
   const href=el.querySelector('a[href]')?.getAttribute('href');
   const id=el.dataset.tplIndexId||href||'seed-'+i;
   merge({id,el:el.cloneNode(true),archive:false,text:normalize(el.dataset.searchText),title:normalize(el.querySelector('.tpl-shop-card__caption, [data-club-jacket] figcaption')?.textContent),price:Number(el.dataset.propriusPrice)||0});
  });
  document.querySelectorAll('#MainContent [data-club-jacket][data-jacket-product-id]').forEach(figure=>{
   const id=figure.dataset.jacketProductId;if(!id)return;
   const el=document.createElement('div');el.dataset.tplIndexPiece='';el.dataset.tplIndexId=id;
   el.dataset.searchText=figure.dataset.jacketSearch||figure.textContent;
   el.dataset.propriusPrice=figure.dataset.jacketPrice||'0';el.append(figure.cloneNode(true));
   merge({id,el,archive:false,text:normalize(el.dataset.searchText),title:normalize(figure.querySelector('figcaption')?.textContent),price:Number(el.dataset.propriusPrice)||0});
  });
  const urlFor=value=>{
   const url=new URL(value,location.href);
   if(url.origin!==location.origin)throw new Error('Catalogue origin mismatch');
   return url;
  };
  const ingest=container=>{
   for(const node of container.querySelectorAll('[data-browse-grid] > [data-browse-piece]')){
    const data=JSON.parse(node.querySelector('[data-browse-product]')?.textContent||'null');
    if(!data?.id)throw new Error('Missing catalogue product data');
    if(!node.querySelector('.tpl-shop-card, [data-club-jacket]'))continue;
    const el=node.cloneNode(true),archive=node.hasAttribute('data-archive-source');
    el.hidden=false;el.removeAttribute('role');el.removeAttribute('data-browse-piece');
    el.setAttribute('data-tpl-index-piece','');el.dataset.tplIndexId=String(data.id);el.dataset.propriusPrice=String(data.price||0);
    el.querySelectorAll('script').forEach(script=>script.remove());
    const searchText=[data.title,data.handle,data.type,data.archiveCategory,...(data.collections||[]).map(c=>c.title),...(data.options||[]).flatMap(o=>(o.values||[]).map(v=>typeof v==='object'?v.name:v)),...(data.variants||[]).flatMap(v=>v.options||[]),data.tags||'',data.description||'',(archive||(data.collections||[]).some(c=>c.handle==='the-archive'))?'TPL by The Proper Label The Archive Sustainability for All':'',data.vendor||'',...(data.variants||[]).map(v=>v.sku||''),el.textContent];
    if(archive){
     const href=data.url||el.querySelector('.tpl-shop-card__caption a[href]')?.getAttribute('href');
     if(href){
      const url=urlFor(href);
      if(/^\/(?:[^/]+\/)?products\/[^/]+\/?$/.test(url.pathname)){
       const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
       const gallery=el.querySelector('.tpl-shop-card__image'),image=gallery?.querySelector('img');
       if(gallery&&image){const link=document.createElement('a');link.className='tpl-shop-card__image';link.href=url.href;link.setAttribute('aria-label',data.title);link.append((gallery.querySelector('.tpl-product-cover')||image).cloneNode(true));gallery.replaceWith(link);}
       const caption=el.querySelector('.tpl-shop-card__caption'),title=caption?.firstElementChild;
       if(title){if(title.tagName==='A')title.href=url.href;else{const link=document.createElement('a');link.href=url.href;link.append(...title.childNodes);title.replaceWith(link);}}
      }
     }
     if(data.archiveOnly){const note=document.createElement('p');note.className='tpl-menu-search-index__availability';note.textContent=copy.availability;el.querySelector('.tpl-shop-card')?.append(note);}
    }
    el.dataset.searchText=searchText.join(' ');
    merge({id:String(data.id),el,archive,text:normalize(el.dataset.searchText),title:normalize(data.title),price:Number(data.price)||0,data,tplLine:archive||(data.collections||[]).some(c=>c.handle==='the-archive')});
   }
  };
  const snapshot=()=>({items:[...records.values()],complete,loading,error});
  const load=()=>{
   if(complete)return Promise.resolve(snapshot());
   if(promise)return promise;
   loading=true;error=false;
   promise=(async()=>{
    try{
     let next=urlFor(panel.dataset.catalogueUrl);const visited=new Set();
     const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)next.searchParams.set('preview_theme_id',preview);
     while(next){
      if(visited.has(next.href))throw new Error('Repeated catalogue page');visited.add(next.href);
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),15000);
      let html;
      try{const response=await fetch(next.href,{credentials:'same-origin',signal:controller.signal,headers:{Accept:'text/html'}});if(!response.ok)throw new Error('Catalogue unavailable');html=await response.text();}finally{clearTimeout(timeout);}
      const documentPage=new DOMParser().parseFromString(html,'text/html'),catalogue=documentPage.querySelector('[data-tpl-browse]');
      if(!catalogue?.querySelector('[data-browse-grid]'))throw new Error('Catalogue missing');
      ingest(catalogue);
      const href=catalogue.querySelector('[data-browse-next]')?.getAttribute('href');
      if(href){next=urlFor(new URL(href,next).href);next.searchParams.set('view','maison-view-all');if(preview)next.searchParams.set('preview_theme_id',preview);}else next=null;
     }
     complete=true;
    }catch{error=true;}
    finally{loading=false;promise=null;}
    return snapshot();
   })();
   return promise;
  };
  return {load,snapshot,copy};
 };
 window.TplCatalogueIndex={normalize,matches,isLineQuery,forMenu:menu=>{if(!instances.has(menu))instances.set(menu,create(menu));return instances.get(menu);}};
})();





